// extracted by mini-css-extract-plugin
export default {"contentMain":"ErrorModal_contentMain__Op2qN","closeButton":"ErrorModal_closeButton__rp18q"};